import moment from "moment/moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { succsesDataDeleteAlert } from "../../alerts/alerts";
import { PaginatedItems } from "../../components/pagination/Pagination";
import useDebounse from "../../helpers/useDebounse";
import OLXIcon from "../../images/icons/icon_OLX.svg";
import TerminalIcon from "../../images/icons/pos-terminal-icon.svg";
import { useGetPageQuery, useSendFormMutation } from "../../redux/services/crmAPI";
import { orderTypes } from "./orderTypesData";

const Orders = () => {
    const [currentPage, setCurrentPage] = useState(1);

    const permissions = useSelector((state) => state.status.permissions);

    const [ordersList, setOrdersList] = useState([]);
    const [search, setSearch] = useState("");
    const [selectedStore, setSelectedStore] = useState(0);
    const [selectedOrderStatus, setSelectedOrderStatus] = useState(0);
    const [selectedOrderType, setSelectedOrderType] = useState("");

    const debounceSearch = useDebounse(search, 1000);

    const orderStatusParams = "&order_status_id=" + selectedOrderStatus;
    const storeParams = "&store_id=" + selectedStore;
    const orderTypeParams = selectedOrderType ? "&type=" + selectedOrderType : "";
    const searchParams = search.length > 0 ? `&search=${debounceSearch}` : "";
    const pagination = "&page=" + currentPage;

    const paramsCombainer = orderStatusParams + storeParams + orderTypeParams + searchParams + pagination;

    const { data: stores } = useGetPageQuery("stores?per_page=200");
    const { data: orderStatuses } = useGetPageQuery("order-statuses");
    const { data: orders, refetch: refetchOrders } = useGetPageQuery("orders?per_page=40" + paramsCombainer, {
        skip: !selectedOrderStatus,
    });
    const [deleteorders, { isLoading, isError }] = useSendFormMutation();

    useEffect(() => {
        if (orderStatuses) {
            setSelectedOrderStatus(orderStatuses[0].id);
        }
    }, [orderStatuses]);

    const listCheckHandler = (e) => {
        if (e.target.checked) {
            setOrdersList([...ordersList, e.target.value]);
        } else if (!e.target.checked) {
            setOrdersList([...ordersList.filter((id) => id !== e.target.value)]);
        }
    };

    const checkAllHandler = () => {
        setOrdersList(orders.data.map((order) => order.id.toString()));
    };

    const deleteOrdersHandler = async () => {
        for (const order of ordersList) {
            await deleteorders({ body: {}, url: "orders/" + order, method: "DELETE" });
        }

        if (!isError) {
            succsesDataDeleteAlert();
        }

        await refetchOrders();
    };

    useEffect(() => {
        if (selectedOrderStatus) {
            const refetch = async () => {
                await refetchOrders();
            };
            refetch();
        }
    }, [paramsCombainer]);

    return (
        <>
            {orders && (
                <div className="content">
                    <div className="col-12">
                        <div className="header-container mb-3">
                            <div className="header">
                                <h1>{orders?.total} Замовлень</h1>
                            </div>
                            <div className="header-functions">
                                <div className="float-end mx-2 my-2">
                                    <Link
                                        className="btn btn-primary"
                                        to={"/order"}
                                    >
                                        Додати замовлення
                                    </Link>
                                </div>
                                <div className="float-end  mx-2 my-2">
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Пошук..."
                                            onChange={(e) => setSearch(e.target.value)}
                                            value={search}
                                        />
                                        <button
                                            className="btn btn-outline-secondary"
                                            type="button"
                                            id="button-addon2"
                                        >
                                            <i className="bi bi-search"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <a
                            className="check_all"
                            onClick={checkAllHandler}
                        >
                            Виділити все
                        </a>
                        <div className="row">
                            <div className="col-12 col-sm-6 col-md-9">
                                <form
                                    id="list_form"
                                    method="post"
                                >
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th data-field="check"></th>
                                                <th data-field="id">ID</th>
                                                <th
                                                    data-field="user_name"
                                                    className="no-mobile"
                                                >
                                                    Товари
                                                </th>
                                                <th data-field="user_total">Сума</th>
                                                <th
                                                    data-field="user_date"
                                                    className="no-mobile"
                                                >
                                                    Дата
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {orders.data.map((order) => {
                                                return (
                                                    <tr key={order.id}>
                                                        <td className="check_area text-right">
                                                            <div className="custom-control custom-checkbox">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    checked={ordersList.includes(order.id.toString())}
                                                                    value={order.id}
                                                                    onChange={(e) => listCheckHandler(e)}
                                                                    id="flexCheckDefault"
                                                                />
                                                                <label className="custom-control-label">&nbsp;</label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <Link
                                                                to={"/order/" + order.id}
                                                                data-id="178626"
                                                                className="mobile-select align-items-center"
                                                            >
                                                                Замовлення&nbsp;#{order.id}
                                                                {order.is_olx ? (
                                                                    <img
                                                                        src={OLXIcon}
                                                                        alt="Print"
                                                                        style={{
                                                                            width: "20px",
                                                                            cursor: "pointer",
                                                                            marginLeft: "5px",
                                                                        }}
                                                                    />
                                                                ) : null}
                                                                {order.is_prom ? (
                                                                    <img
                                                                        src={require("../../images/icons/Prom.jpg")}
                                                                        alt="Print"
                                                                        style={{
                                                                            width: "20px",
                                                                            cursor: "pointer",
                                                                            marginLeft: "5px",
                                                                        }}
                                                                    />
                                                                ) : null}
                                                                {order.is_card ? (
                                                                    <i class="bi bi-credit-card ms-1"></i>
                                                                ) : null}
                                                                {order.is_terminal ? (
                                                                    <img
                                                                        src={TerminalIcon}
                                                                        alt="Print"
                                                                        style={{
                                                                            width: "14px",
                                                                            cursor: "pointer",
                                                                            marginLeft: "5px",
                                                                        }}
                                                                    />
                                                                ) : null}
                                                                {order?.ttns?.[0]?.ttn ? (
                                                                    <img
                                                                        src={require("../../images/icons/nova.png")}
                                                                        alt=""
                                                                        style={{ width: "20px", marginLeft: "5px" }}
                                                                    />
                                                                ) : null}
                                                                {order?.is_exchange ? (
                                                                    <img
                                                                        src={require("../../images/icons/change.png")}
                                                                        alt=""
                                                                        style={{ width: "20px", marginLeft: "5px" }}
                                                                    />
                                                                ) : null}
                                                            </Link>
                                                            <div>
                                                                <div className="product_store">
                                                                    {order?.store?.title}
                                                                </div>
                                                                <div className="badge badge-info bg-info">
                                                                    {order?.ttns?.[0]?.ttn
                                                                        ? "ТТН: " + order?.ttns?.[0]?.ttn
                                                                        : ""}
                                                                </div>
                                                                {order?.ttns?.[0]?.ttn && <br />}
                                                                <div className="badge badge-info bg-warning">
                                                                    {order?.note}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="no-mobile">
                                                            <ul className="list_purchaches">
                                                                {order?.products.map((product) => {
                                                                    return (
                                                                        <li key={product.id}>
                                                                            <Link to={"/product/" + product.id}>
                                                                                {product.title} ({" "}
                                                                                {product.imei_sn.slice(
                                                                                    product.imei_sn.length - 5
                                                                                )}
                                                                                )
                                                                                <span className="badge bg-danger">
                                                                                    {product?.shipper?.title_short}
                                                                                </span>
                                                                            </Link>
                                                                        </li>
                                                                    );
                                                                })}
                                                                {order?.services.map((service) => {
                                                                    return (
                                                                        <li key={service.id}>
                                                                            <Link to={"/service/" + service.id}>
                                                                                {service.title}
                                                                            </Link>
                                                                        </li>
                                                                    );
                                                                })}
                                                            </ul>
                                                        </td>
                                                        <td>{order.total_price}&nbsp;грн</td>
                                                        <td className="no-mobile">
                                                            {moment(order.created_at).format("DD.MM.YYYY")}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                    <div className="d-flex mb-3">
                                        {/* <select name="action" className="form-select" style={{ width: "auto" }}>
                                            <option value="delete">Видалити</option>{" "}
                                        </select> */}
                                        {/* <button className="btn btn-info mx-3" onClick={deleteOrdersHandler}>
                                            {isLoading ? "Завантаження" : "Виконати"}
                                        </button> */}
                                    </div>
                                    <nav>
                                        <PaginatedItems
                                            pageCount={orders.last_page}
                                            setCurrentPage={setCurrentPage}
                                        />
                                    </nav>
                                </form>
                            </div>

                            <div className="col-12 col-sm-6 col-md-3">
                                <div className="list-group margin20">
                                    {orderTypes.map((type) => {
                                        return (
                                            <div
                                                className={
                                                    type.value === selectedOrderType
                                                        ? "list-group-item fake-a active"
                                                        : "list-group-item fake-a"
                                                }
                                                onClick={() => setSelectedOrderType(type.value)}
                                                key={type.value}
                                            >
                                                {type.title}
                                            </div>
                                        );
                                    })}
                                </div>
                                {/* <div className="list-group list-group-horizontal-sm margin20">
                                    <a className="list-group-item flex-fill active" href="/orders?status=2">
                                        Всі
                                    </a>
                                    <a className="list-group-item flex-fill " href="/orders?status=2&amp;rro=1">
                                        пРРО
                                    </a>
                                </div> */}
                                <div className="list-group margin20">
                                    {orderStatuses.map((status) => {
                                        return (
                                            <div
                                                className={
                                                    status.id === selectedOrderStatus
                                                        ? "list-group-item fake-a active"
                                                        : "list-group-item fake-a"
                                                }
                                                onClick={() => setSelectedOrderStatus(status.id)}
                                                key={status.id}
                                            >
                                                {status.title}
                                            </div>
                                        );
                                    })}
                                </div>

                                <div className="list-group margin20">
                                    <div
                                        className={
                                            selectedStore === 0
                                                ? "list-group-item fake-a active"
                                                : "list-group-item fake-a"
                                        }
                                        onClick={() => setSelectedStore(0)}
                                    >
                                        Всі магазини
                                    </div>
                                    {stores?.data.map((store) => {
                                        return (
                                            <div
                                                className={
                                                    selectedStore === store.id
                                                        ? "list-group-item fake-a active"
                                                        : "list-group-item fake-a"
                                                }
                                                onClick={() => setSelectedStore(store.id)}
                                                key={store.id}
                                            >
                                                {store.title}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Orders;
